module.exports = __webpack_public_path__ + "static/media/pricing2.9ed58ff4.jpg";